import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e90118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-login" }, " Continue with Google ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "signup-flow-container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signin($event)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", { src: _ctx.g_icon }, null, 8, _hoisted_2)
    ]),
    _hoisted_3
  ]))
}